import { stringToDocumentFragment } from "@gr-exports/async/dom";
import { executeInlineScripts } from "@gr-exports/async/hardcore";
import type { NexusHandler } from "../../nexus/function/function.types";
import type { DomRaw } from "../index.js";

export interface InsertHtmlFragmentOptions {
  /**
 *
 *
 *
 *
 */
  activateInlineScripts?: boolean;
}

export const insertHtmlFragment = ((htmlString, parent = document.body, options = {}): Node[] => {
  const { activateInlineScripts: runInlineScripts = true } = options;
  const fragment = stringToDocumentFragment(htmlString);
  const result = [...fragment.childNodes];
  parent.appendChild(fragment);

  if (runInlineScripts) executeInlineScripts(parent);
  return result;
}) satisfies NexusHandler<DomRaw["insertHtmlFragment"]>;
